import React from "react";
import { Typography } from "@kelp-dao/kernel-design-system";
import { trackEvent } from "utils";
import { VAULT_DISCLAIMER_CLICKED } from "@constants/analytics";

const VaultDisclaimer: React.FC = () => {
  const handleDisclaimerClick = () => {
    trackEvent(VAULT_DISCLAIMER_CLICKED, {
      location: "vault_landing",
    });
  };

  return (
    <div className="w-full pt-4 mb-10 border-t border-border-default">
      <Typography type="body" variant="xsmall" className="text-text-secondary">
        By accessing Gain, you acknowledge and agree to the risks involved and
        agree to the{" "}
        <a
          href="https://docs.google.com/document/d/1KnAvqWDWXr-GpU3c1g_CtQU6y1fpxX9oaGRcrx4lcWQ"
          target="_blank"
          rel="noopener noreferrer"
          className="underline underline-offset-2 text-text-primary hover:text-text-secondary transition-colors"
          onClick={handleDisclaimerClick}
        >
          Gain Disclaimers
        </a>
      </Typography>
    </div>
  );
};

export default VaultDisclaimer;
